import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24.663",
  height: "24.664"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  "data-name": "Group 8064",
  fill: "#fff"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 1803",
    d: "M21.3 8.573A9.716 9.716 0 0 1 7.849 20.957l.8-.907-5.1-1.034 1.655 4.936.877-.992a12.371 12.371 0 0 0 5.812 1.7q.226.008.452.008a12.334 12.334 0 0 0 11.362-17.1Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 1804",
    d: "M7.472 3.915a9.676 9.676 0 0 1 9.331-.215l-.8.908 5.1 1.026L19.44.7l-.875.994A12.332 12.332 0 0 0 .953 17.085l2.408-1.009A9.732 9.732 0 0 1 7.472 3.915Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }